import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#E11900"
        d="M12 20a8 8 0 110-16 8 8 0 010 16zm0-1.6a6.4 6.4 0 100-12.8 6.4 6.4 0 000 12.8zm-.8-4h1.6V16h-1.6v-1.6zm0-6.4h1.6v4.8h-1.6V8z"
      ></path>
    </svg>
  )
}

export default Icon
